@let progress = loadingService.progress();

<div class="fixed inset-0 z-50 bg-base-100">
  <app-screen-loading-backdrop />

  <div
    class="pointer-events-none relative flex h-full flex-col items-center justify-center gap-4 p-8 px-[30%]"
  >
    <div
      #hero
      class="grid h-32 items-end justify-items-center [image-rendering:pixelated]"
    >
      @if (heroJob(); as job) {
        @for (shown of [job]; track shown.id) {
          <div
            class="col-start-1 row-start-1 origin-bottom scale-200"
            (animate.enter)="onHeroEnter($event)"
            (animate.leave)="onHeroLeave($event)"
          >
            <app-atlas-animation
              spritesheet="job"
              [assetName]="shown.sprite"
              [frames]="shown.frames"
            />
          </div>
        }
      }
    </div>

    <app-bar-progress
      class="w-[50%]"
      color="primary"
      [shimmer]="true"
      [value]="progress.percent"
    />

    <!-- Tracked by text so each new step fades in; nowrap keeps a long label from shifting the hero and bar. -->
    @for (step of [progress]; track step.label) {
      <p
        class="type-muted whitespace-nowrap"
        (animate.enter)="anim.reflowEnter($event.target)"
      >
        {{ step.label }}
      </p>
    }
  </div>
</div>
